import EntityCard from './EntityCard';

export default EntityCard;



// WEBPACK FOOTER //
// ./src/components/EntityCard/index.ts